import http from '../../utils/http';
import _get from 'lodash/get';
import $store from '@/store'

const rootUrl = '/api';
const dentalxBaseUrl = '/dentalx/api';

const addTeamId = (params) => {
	return {  ...params, teamID: $store.getters.teamID, id: params.orderID }
};

const addId = (params) => {
	return { ...params, id: params.orderID, orderID: undefined }
};
export const orderDetail = {
	dental: {
		/**
		 * 添加评论
		 */
		addComment( data ) {
			return http.post( `${dentalxBaseUrl}/dentalxAddOrderComment`, data, { errCode: 'addComment' });
		},
		/**
		 * 获取评论列表
		 */
		getListComments ( params ) {
			return http.get( `${dentalxBaseUrl}/dentalxListOrderComments`, params, { errCode: 'getListComments' });
		},
		/**
		 * 用户补充文件
		 */
		supplyOrderFiles( data ) {
			return http.post( `${dentalxBaseUrl}/dentalxSupplyOrderFiles`, data, { errCode: 'getDentalList' });
		},
		/**
		 * 获取订单详情
		 */
		designOrderInfo ( params ) {
			return http.get( `${dentalxBaseUrl}/dentalxDesignOrderInfo`, params, { errCode: 'designOrderInfo' });
		},
        /**
         * 获取下载列表
         * 
         */
        orderDownloadList( params ) {
            return http.get( `${dentalxBaseUrl}/dentalxOrderDownloadList`, params, { errCode: 'orderDownloadList' });
        },
        /**
         * 获取下载url
         */
        getDownLoadURL( data ) {
            return http.post( `${dentalxBaseUrl}/dentalxGetDownLoadURL`, data, { errCode: 'getDownLoadURL' });
        },
		/**
		 * 获取影像集配置
		 */
		fetchImageSetting( params ) {
			return http.get( `${dentalxBaseUrl}/dentalxFetchImageSetting`, params, { errCode: 'fetchImageSetting' });
		},
		/**
		 * 订单验收-不可用原因列表
		*/
		dentalxCloudListAiLabel(params){
			return http.get( `${dentalxBaseUrl}/dentalxCloudListAiLabel`, params, { errCode: 'order' });
		},
		/**
		 * 订单验收-提交不可用原因
		*/
		dentalxSetOrderAiReason(data){
			return http.post( `${dentalxBaseUrl}/dentalxSetOrderAiReason`, data, { errCode: 'order' });
		}
	},
	dentalx: {
		/**
		 * 添加评论
		 */
		addComment( data ) {
			return http.post( `${rootUrl}/dentalxAddOrderCommentBackUp`, { isBackUp: true, ...data, publisherName: 'sys' }, { errCode: 'addComment' });
		},
		/**
		 * 获取评论列表
		 */
		getListComments ( params ) {
			return http.get( `${rootUrl}/dentalxListOrderCommentsBackUp`, { isBackUp: true, ...params }, { errCode: 'getListComments' });
		},
		/**
		 * 获取订单详情
		 */
		designOrderInfo ( params ) {
			return http.get( `${rootUrl}/dentalxDesignOrderDetail`, params, { errCode: 'designOrderInfo' });
		},
		/**
		 * 获取下载列表
		 * 
		 */
		orderDownloadList( params ) {
				return http.get( `${rootUrl}/dentalxOrderAdminDownloadList`, params, { errCode: 'orderDownloadList' });
		},
		/**
		 * 获取下载url
		 */
		getDownLoadURL( data ) {
				return http.post( `${rootUrl}/dentalxGetAdminDownLoadURL`, data, { errCode: 'getDownLoadURL' });
		},
		/**
		 * 获取影像集配置
		 */
		fetchImageSetting( params ) {
			return http.get( `${rootUrl}/dentalxFetchImageSetting`, params, { errCode: 'fetchImageSetting' });
		},
		/**
		 * 订单验收-不可用原因列表
		*/
		dentalxCloudListAiLabel(params){
			return http.get( `${rootUrl}/dentalxCloudListAiLabel`, params, { errCode: 'order' });
		}
	},
	dentalxDesign: {
		/**
		 * 添加评论
		 */
		addComment( data ) {
			return http.post( `${rootUrl}/dentalxAddTransferOrderCommentByAdmin`, { isBackUp: true, ...data, publisherName: 'sys' }, { errCode: 'addComment' });
		},
		/**
		 * 获取评论列表
		 */
		getListComments ( params ) {
			return http.get( `${rootUrl}/dentalxListTransferCommentsByAdmin`, addId({ isBackUp: true, ...params }), { errCode: 'getListComments' });
		},
		/**
		 * 用户补充文件
		 */
		supplyOrderFiles( data ) {
			return http.post( `${rootUrl}/dentalxSupplyTransferOrderFiles`, {  ...data, id: data.orderID }, { errCode: 'getDentalList' });
		},
		/**
		 * 获取设计单详情
		 */
		designOrderInfo ( params ) {
			return http.get( `${rootUrl}/dentalxTransferOrderDetailByAdmin`, addId(params), { errCode: 'designOrderInfo' });
		},
		/**
		 * 获取下载列表
		 * 
		 */
		orderDownloadList( params ) {
				return http.get( `${rootUrl}/dentalxTransferOrderDownLoadListByAdmin`, addId(params), { errCode: 'orderDownloadList' });
		},
		/**
		 * 获取下载url
		 */
		getDownLoadURL( data ) {
				return http.post( `${rootUrl}/dentalxGetTransferOrderDownloadURLByAdmin`, addId(data), { errCode: 'getDownLoadURL' });
		},
		/**
		 * 获取影像集配置
		 */
		fetchImageSetting( params ) {
			return http.get( `${rootUrl}/dentalxFetchImageSetting`, params, { errCode: 'fetchImageSetting' });
		},
		/**
		 * 订单验收-不可用原因列表
		*/
		dentalxCloudListAiLabel(params){
			return http.get( `${rootUrl}/dentalxCloudListAiLabel`, params, { errCode: 'order' });
		}
	},
	designerService: {
		/**
		 * 添加评论
		 */
		addComment( params ) {
			return http.post( `${rootUrl}/dentalxAddTransferOrderComment`, addTeamId(params), { errCode: 'addComment' });
		},
		/**
		 * 获取评论列表
		 */
		getListComments ( params ) {
			return http.get( `${rootUrl}/dentalxTransferOrderComments`, addTeamId(params), { errCode: 'getListComments' });
		},
		/**
		 * 用户补充文件
		 */
		supplyOrderFiles( params ) {
			return http.post( `${rootUrl}/dentalxSupplyTransferOrderFiles`, addTeamId(params), { errCode: 'getDentalList' });
		},
		/**
		 * 获取订单详情
		 */
		designOrderInfo ( params, type = 'order') {
			if ( type === 'aiOrder' ) {
				return http.get( `${rootUrl}/dentalxDesignOrderInfo`, params, { errCode: 'designOrderInfo' });
			} 
			return http.get( `${rootUrl}/dentalxTransferOrderDetail`, addTeamId(params), { errCode: 'designOrderInfo' });
		},
        /**
         * 获取下载列表
         * 
         */
        orderDownloadList( params ) {
            return http.get( `${rootUrl}/dentalxTransferOrderDownLoadList`, addTeamId(params), { errCode: 'orderDownloadList' });
        },
        /**
         * 获取下载url
         */
        getDownLoadURL( params ) {
            return http.post( `${rootUrl}/dentalxGetTransferOrderDownloadURL`, addTeamId(params), { errCode: 'getDownLoadURL' });
        },
		/**
		 * 获取影像集配置
		 */
		fetchImageSetting( params ) {
			return http.get( `${rootUrl}/dentalxFetchImageSetting`, addTeamId(params), { errCode: 'fetchImageSetting' });
		},
		/**
		 * 订单验收-不可用原因列表
		*/
		dentalxCloudListAiLabel(params){
			return http.get( `${rootUrl}/dentalxCloudListAiLabel`, params, { errCode: 'order' });
		},
		/**
		 * 订单验收-提交不可用原因
		*/
		dentalxSetOrderAiReason(data){
			return http.post( `${rootUrl}/dentalxSetOrderAiReason`, data, { errCode: 'order' });
		}
	}
};

export default orderDetail;